import { useInfiniteQuery, useQuery } from '@tanstack/react-query';
import { getPrivateAudios } from '../../services';
import { AudioModelType, FilteringSortingParams } from 'apps/t2c-fe/utils';

export const useGetPrivateAudios = (params: FilteringSortingParams, model?: AudioModelType) => {
  return useInfiniteQuery(
    ['privateAudios', params, model],
    ({ pageParam = 1 }) => getPrivateAudios({ ...params, page: pageParam }, model),
    {
      getNextPageParam: (lastPage, allPages) => {
        const currentPage = allPages.length;
        const totalItemsFetched = currentPage * (params?.limit ?? 20);

        if (totalItemsFetched < lastPage.count) {
          return currentPage + 1;
        } else {
          return undefined;
        }
      },
    }
  );
};
